import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { Link} from 'react-router-dom';
import HotelReservationForm from './HotelReservationForm';
import BusinessLogin from "./BusinessLogin"
import BusinessProfileEditor from "./BusinessProfileEditor"
import ImageUpload from "./ImageUpload" 
import "./BusinessProfile.css"
import Navbar from './Navbar';
import CoverImageUpload from './CoverImageUpload';
import BusinessLessons from './BusinessLessons';
import { FiSettings } from 'react-icons/fi';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import ReservationDashboard from "./ReservationDashboard"



const BusinessProfile = () => {
  const { businessLogout, business, businessToken, profileWorkHours, fetchBusiness} = useAuth();
  const [updateBusinessProfile, setUpdateBusinessData] = useState({
    name: '',
    owner: "",
    ic: '',
    dic: '',
    email: '',
    phone: '',
    description: '',
    street: '',
    houseNumber: '',
    city: '',
    postalCode: '',
  });

  const defaultWorkHours = [
    { day: 'Pondělí', start: '00:00', end: '00:00' },
    { day: 'Úterý', start: '00:00', end: '00:00' },
    { day: 'Středa', start: '00:00', end: '00:00' },
    { day: 'Čtvrtek', start: '00:00', end: '00:00' },
    { day: 'Pátek', start: '00:00', end: '00:00' },
    { day: 'Sobota', start: '00:00', end: '00:00' },
    { day: 'Neděle', start: '00:00', end: '00:00' },
  ];
  
  const [workHours, setWorkHours] = useState(
    profileWorkHours?.length
      ? profileWorkHours.map((entry) => ({
          day: entry.day,
          start: entry.start,
          end: entry.end,
        }))
      : defaultWorkHours // Pokud `profileWorkHours` není dostupné, použij výchozí hodnoty
  );

  // Service
  const [services, setServices] = useState({
    name: '',
    description: '',
    price: '',
    duration: '',
    sex: "everyone",
  });

  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true)
  const [activeDashboard, setActiveDashobard] = useState("reservations")
  const [dashboardMenuOpen, setDashboardMenuOpen] = useState(false)

  const toogleDashboardMenu = () => {
    setDashboardMenuOpen(!dashboardMenuOpen)
  }


  useEffect(() => {
    if (profileWorkHours?.length) {
      setWorkHours(profileWorkHours);
    }
  }, [profileWorkHours]);


 //Pridani sluzby
  const addService = async (e) => {
    e.preventDefault()
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/business/profile/services/add`,
        services,
        {
          headers: {
            Authorization: `Bearer ${businessToken}`,
          },
        }
      );
      console.log(response.data.message)
      setServices({
        name: '',
        description: '',
        price: '',
        duration: '',
        sex: "everyone",
      })

    } catch (err) {
      setMessage(err.response?.data?.message || err.message);
    } finally {
      fetchBusiness()
    }
  };

  const deleteService = async (serviceId) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/business/profile/services/${serviceId}/delete`, 
        {
          headers: {
            Authorization: `Bearer ${businessToken}`,
          },
        }
      )
      console.log(response.data.message)
    } catch (err) {
      setMessage(err.response?.data?.message || "Nastala chyba při mazání služby")

    }

  }

  //ServiceList 
  const [serviceList, setServiceList] = useState([])

  useEffect(() => {
  const fetchServiceList = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/profile`, {
        headers: {
          Authorization: `Bearer ${businessToken}`
        },
      })
      setServiceList(response.data.services)
    } catch (err) {
      setMessage(err.response?.data?.message || "Nelze načíst služby")
    }
  }
  if (businessToken) {
    fetchServiceList()  // Načíst seznam služeb, pouze pokud je businessToken k dispozici
  }
}, [serviceList, businessToken])


  //Aktualizace
  useEffect(() => {
    if (business) {
      setUpdateBusinessData({
        name: business.name || '',
        owner: business.owner || '',
        ic: business.ic || '',
        dic: business.dic || '',
        email: business.email || '',
        phone: business.phone || '',
        description: business.description || '',
        street: business.street || '',
        houseNumber: business.houseNumber || '',
        city: business.city || '',
        postalCode: business.postalCode || '',
      });
    }
  }, [business]);

  const inputChange = (e) => {
    const { name, value } = e.target;
    setUpdateBusinessData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  
  const formSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const updatedData = {
        ...updateBusinessProfile,
        workHours,
      };

      const response = await axios.put(`${process.env.REACT_APP_API_URL}/business/profile`, updatedData, {
        headers: {
          Authorization: `Bearer ${businessToken}`,
        },
      });
      setMessage(response?.data.message || "Profil aktualizován");

    } catch (err) {
      setMessage(err.response?.data?.message || "Nastala chyba při aktualizaci profilu.");
    } finally {
      setLoading(false);
      setTimeout(() => {
        setMessage(null)
      }, 2000)
    }
  };

  const handleWorkhoursChange = (index, field, value) => {
    const updatedWorkHours = [...workHours];
  
    if (updatedWorkHours[index]) {  // Zajistíme, že objekt na daném indexu existuje
      updatedWorkHours[index][field] = value;
    }
   
    setWorkHours(updatedWorkHours);
  
    setUpdateBusinessData((prevData) => ({
      ...prevData,
      workHours: updatedWorkHours, // Zahrnutí upravených pracovních hodin
    }));
  };

  const handleServicesChange = (e) => {
    const { name, value } = e.target;
    setServices((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //Vyber reservacniho systemu
  const [settings, setSettings] = useState({
    basicReservation: business?.basicReservation || false,
    salonReservation: business?.salonReservation || false,
    hotelReservation: business?.hotelReservation || false,
    groupLessons: business?.groupLessons || false,
    homepage: business?.homepage || true,
    visiblePhoto: business?.visiblePhoto || true,
    visibleWorkHours: business?.visibleWorkHours || true,
    visibleDescription: business?.visibleDescription || true,
    visibleCompanyData: business?.visibleCompanyData || true,
    visibleMap: business?.visibleMap || true,
    visibleServices: business?.visibleServices || true,
    coverImage: business?.coverImage || false,
  });

  useEffect(() => {
    if (business) {
      setSettings({
        basicReservation: business.basicReservation,
        salonReservation: business.salonReservation,
        hotelReservation: business.hotelReservation,
        groupLessons: business.groupLessons,
        homepage: business.homepage,
        visiblePhoto: business.visiblePhoto,
        visibleWorkHours: business.visibleWorkHours,
        visibleDescription: business.visibleDescription,
        visibleCompanyData: business.visibleCompanyData,
        visibleMap: business.visibleMap,
        visibleServices: business.visibleServices,
        coverImage: business.coverImage,
      });
    }
  }, [business]);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: checked,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/business/reservation-update`,
        { businessId: business._id, updateData: settings },
        { headers: { Authorization: `Bearer ${businessToken}` } }
      );
      setMessage(response.data.message);

    } catch (err) {
      setMessage(err.response?.data?.message || "Chyba při aktualizaci.");
    } finally {
      setTimeout(() => {
        setMessage(null)
        fetchBusiness()
      })
      
    }
  };

  //smazani uctu
  const handleDeleteAccount = async () => {
    window.confirm("Opravdu chcete smazat svůj účet? Tuto akci nelze vrátit zpět.");
    if (business && businessToken) {
      try {
        const response = await axios.delete(`${process.env.REACT_APP_API_URL}/business/profile/delete`,
          {
            headers: {
              Authorization: `Bearer ${businessToken}`
            }
          }
        )
        alert(response.data.message)
      } catch (err) {
        alert(err.response?.data?.message || "Nastala chyba při mazání účtu.")
      } finally {
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      }
    }
  }

  //zmena hesla
  const handlePasswordChange = async () => {
    if (business) {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/business/forgot-password`, {
          email: business.email,
        })
        setMessage(response.data.message)
      } catch(err) {
        setMessage(err.respnse?.data?.message)
      }
    }
  }
  
  useEffect(() => {
    if (business || businessToken) {
      setPageLoading(false)
    } else if (!business || !businessToken) {
      setPageLoading(false)
    }
  }, [business, businessToken])

  const orderUp = async (serviceId) => {
   
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/business/profile/${business._id}/services/${serviceId}/orderup`,
        {},
        {
          headers: {
            "Authorization": `Bearer ${businessToken}`
        }
       }
      )
      console.log(response.data.message)
    } catch (err) {
      console.log(err.response?.data?.message)
    } finally {
      fetchBusiness()
    }
  }

  const orderDown = async (serviceId) => {
    if (businessToken) {
      try {
        const response = await axios.put(`${process.env.REACT_APP_API_URL}/business/profile/${business._id}/services/${serviceId}/orderdown`, 
          {},
          {
            headers: {
              "Authorization": `Bearer ${businessToken}`
            }
          }
        )
        console.log(response.data.message)
      } catch (err) {
        console.log(err.response?.data?.message)
      } finally {
        fetchBusiness()
      }
    }
  }
  useEffect(() => {
    if (business) {

      if (!business.salonReservation && !business.basicReservation) {
        setActiveDashobard("zobrazeni")
      }
    }
    
  }, [business])


  const freeReservation = (allReservation, newReservation) => {
    const finalNumber = allReservation - newReservation
    return finalNumber
  }

  const [iframeOpen, setIframeOpen] = useState(null)


    if (pageLoading) {
      return <div className='min-height'>
        <Navbar />
        <div className='loading-spinner center-spinner'></div>
        </div>
    }

    // Pokud není uživatel přihlášený
    if (!business || !businessToken) {
      return <div>
          <BusinessLogin setTokenMessage={setMessage} />
        </div>
  }



  

  return (
    <div>
        <Navbar />
      <div>
      <div>
  <button
        className="menu-toggle-button"
        onClick={toogleDashboardMenu}
        aria-label="Toggle menu"
      >
         <FiSettings size={24} />
      </button>
  </div>
        <div className="dashboard-container">

  {dashboardMenuOpen && <div>
    <div className='overlay' onClick={() => setDashboardMenuOpen(false)}></div>
    <div className={`dashboard-menu ${dashboardMenuOpen ? "open" : ""}`}>
  <Link to="/" className="dashboard-name">
    <h1>RESANIO</h1>
  </Link>

  <div className="menu-section">
  {business.basicReservation || business.salonReservation ? <button
      type="button"
      className={activeDashboard === "reservations" ? "menu-button-active" : ""}
      onClick={() => {
        setActiveDashobard("reservations")
        setDashboardMenuOpen(false)
      }}
    >
      Přehled
    </button> : ""}
    <button
      type="button"
      className={activeDashboard === "zobrazeni" ? "menu-button-active" : ""}
      onClick={() => {
        setActiveDashobard("zobrazeni");
        setDashboardMenuOpen(false); // zavře menu
      }}
    >
      Zobrazení
    </button>
    <div className="menu-group">
      {business.hotelReservation && (
        <button
          type="button"
          className={activeDashboard === "booking" ? "menu-button-active" : ""}
          onClick={() => {
            setActiveDashobard("booking");
            setDashboardMenuOpen(false);
          }}
        >
          Booking systém
        </button>
      )}
      {business.groupLessons && (
        <button
          type="button"
          className={activeDashboard === "skupinove" ? "menu-button-active" : ""}
          onClick={() => {
            setActiveDashobard("skupinove");
            setDashboardMenuOpen(false);
          }}
        >
          Skupinové lekce
        </button>
      )}
    </div>
  </div>

  <div className="menu-section">
    {business.visibleDescription && (
      <button
        type="button"
        className={activeDashboard === "popis" ? "menu-button-active" : ""}
        onClick={() => {
          setActiveDashobard("popis");
          setDashboardMenuOpen(false);
        }}
      >
        Popis
      </button>
    )}
    {(business.visibleServices || business.salonReservation) && (
      <button
        type="button"
        className={activeDashboard === "sluzby" ? "menu-button-active" : ""}
        onClick={() => {
          setActiveDashobard("sluzby");
          setDashboardMenuOpen(false);
        }}
      >
        Služby
      </button>
    )}
    {business.visiblePhoto && (
      <button
        type="button"
        className={activeDashboard === "galerie" ? "menu-button-active" : ""}
        onClick={() => {
          setActiveDashobard("galerie");
          setDashboardMenuOpen(false);
        }}
      >
        Galerie
      </button>
    )}
    {business.coverImage && (
      <button
        type="button"
        className={activeDashboard === "uvodni" ? "menu-button-active" : ""}
        onClick={() => {
          setActiveDashobard("uvodni");
          setDashboardMenuOpen(false);
        }}
      >
        Úvodní obrázek
      </button>
    )}
    {business.visibleWorkHours && (
      <button
        type="button"
        className={activeDashboard === "doba" ? "menu-button-active" : ""}
        onClick={() => {
          setActiveDashobard("doba");
          setDashboardMenuOpen(false);
        }}
      >
        Pracovní doba
      </button>
    )}
    {business.visibleCompanyData && (
      <button
        type="button"
        className={activeDashboard === "kontakt" ? "menu-button-active" : ""}
        onClick={() => {
          setActiveDashobard("kontakt");
          setDashboardMenuOpen(false);
        }}
      >
        Kontaktní údaje
      </button>
    )}
  </div>
        <div>
        <button className='delete-account' onClick={handleDeleteAccount}>Smazat účet</button>
      </div>
</div>

  </div>}
  <div className="dashboard-menu">
    <Link to="/" className='dashboard-name'><h1>RESANIO</h1></Link>
       <div className="menu-section">
       {business.basicReservation || business.salonReservation ? <button
      type="button"
      className={activeDashboard === "reservations" ? "menu-button-active" : ""}
      onClick={() => {
        setActiveDashobard("reservations")
        setDashboardMenuOpen(false)
      }}
    >
      Přehled
    </button> : ""}
   { <button type="button" className={activeDashboard==="zobrazeni" ? "menu-button-active" : ""} onClick={() => setActiveDashobard("zobrazeni")}>Zobrazení</button>}
    <div className="menu-group">
     { business.hotelReservation && <button type="button"
      className={activeDashboard==="booking" ? "menu-button-active" : ""}
      onClick={() => {
        setActiveDashobard("booking")
        setDashboardMenuOpen(false)
        }
      }>
        Booking systém
      </button>}
     { business.groupLessons && <button type="button" className={activeDashboard==="skupinove" ? "menu-button-active" : ""} onClick={() => setActiveDashobard("skupinove")}>Skupinové lekce</button>}
    </div>
  </div>

  <div className="menu-section">
    {business.visibleDescription && <button type="button" className={activeDashboard==="popis" ? "menu-button-active" : ""} onClick={() => setActiveDashobard("popis")}>Popis</button>}
    {(business.visibleServices || business.salonReservation) && <button type="button" className={activeDashboard==="sluzby" ? "menu-button-active" : ""} onClick={() => setActiveDashobard("sluzby")}>Služby</button>}
    {business.visiblePhoto && <button type="button" className={activeDashboard==="galerie" ? "menu-button-active" : ""} onClick={() => setActiveDashobard("galerie")}>Galerie</button>}
    {business.coverImage && <button type="button" className={activeDashboard==="uvodni" ? "menu-button-active" : ""} onClick={() => setActiveDashobard("uvodni")}>Úvodní obrázek</button>}
    {business.visibleWorkHours && <button type="button" className={activeDashboard==="doba" ? "menu-button-active" : ""} onClick={() => setActiveDashobard("doba")}>Pracovní doba</button>}
    {business.visibleCompanyData && <button type="button" className={activeDashboard==="kontakt" ? "menu-button-active" : ""} onClick={() => setActiveDashobard("kontakt")}>Kontaktní údaje</button>}
  </div>
  <div className='signout-buttons'>
      <button className='profile-button' onClick={handlePasswordChange}>Změnit heslo</button>

      <button className='sign-out' onClick={businessLogout}>Odhlásit se</button>
      </div>
      <div>
        <button className='delete-account' onClick={handleDeleteAccount}>Smazat účet</button>
      </div>
  </div>

  <div className="dashboard-content">
    {business.subscriptionStatus !== "active" && business.trialForever && (
      <div className="inactive-profile">
        <div>
          <p><strong>Služba: </strong>Trial Forever</p>
          <p><strong>Dostupné rezervace: </strong>
            {freeReservation(
              process.env.REACT_APP_MONTHLY_FREE_RESERVATION,
              business.trialFreeReservations.length
            )}
          </p>
        </div>
        {business.fromBranch ? (
          <p>Kontaktujte svého správce</p>
        ) : (
          <Link to="/business/profile/paymentform" className="profile-button">
            Správa předplatného
          </Link>
        )}
      </div>
    )}
    <div className='margin-top-50px'>
  {
    activeDashboard === "reservations" && <div>
      <ReservationDashboard />
    </div>
  }

 {activeDashboard === "zobrazeni" && <div>
    
    <form onSubmit={handleSubmit}>
        <div className='visible-container'>
          <div className='hotel-number'>
            <h2 className='check-title'>Rezervační systém Základní:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="basicReservation"
                checked={settings.basicReservation}
                onChange={handleCheckboxChange}
              />
          </div>
          {iframeOpen !== 0 && <button className='profile-button' onClick={() => setIframeOpen(0)}>Zkopíruj na vlastní web</button>}
          {business.basicReservation && (iframeOpen === 0 || iframeOpen === "0") && <div className='iframe-text'>
            <p>
                {`<iframe scrolling='no'\n title="Reservation"\n style={{ width: '100%', height: '1200px', border: 'none' }}\n src={"/business/public/${business._id}/basicreservation/reservationform"}>\n</iframe>`}
            </p>
            <button className='profile-button' onClick={() => setIframeOpen(null)}>Zavřít</button>
          </div>
          }

          <div className='hotel-number'>
            <h2 className='check-title'>Rezervační systém se Sloty:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="salonReservation"
                checked={settings.salonReservation}
                onChange={handleCheckboxChange}
              />
          </div>
          {business.salonReservation && iframeOpen !== 1 && <button className='profile-button' onClick={() => setIframeOpen(1)}>Zkopíruj na vlastní web</button>}
          {business.salonReservation && (iframeOpen === 1 || iframeOpen === "1") && <div className='iframe-text'>
            <p>
                {`<iframe scrolling='no'\n title="Reservation"\n style={{ width: '100%', height: '1200px', border: 'none' }}\n src={"/business/public/${business._id}/reservationform"}>\n</iframe>`}
            </p>
            <button className='profile-button' onClick={() => setIframeOpen(null)}>Zavřít</button>
          </div>
          }
          <div className='hotel-number'>
          <h2 className='check-title'>Rezervační systém pro Booking:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="hotelReservation"
                checked={settings.hotelReservation}
                onChange={handleCheckboxChange}
              />
    
          </div>
          {business.hotelReservation && iframeOpen !== 2 && <button className='profile-button' onClick={() => setIframeOpen(2)}>Zkopíruj na vlastní web</button>}
          {business.hotelReservation && (iframeOpen === 2 || iframeOpen === "2") && <div className='iframe-text'>
            <p>
                {`<iframe scrolling='no'\n title="Reservation"\n style={{ width: '100%', height: '1200px', border: 'none' }}\n src={"/business/public/${business._id}/bookingreservation/reservationform"}>\n</iframe>`}
            </p>
            <button className='profile-button' onClick={() => setIframeOpen(null)}>Zavřít</button>
          </div>
          }
          <div className='hotel-number'>
          <h2 className='check-title'>Skupinové lekce:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="groupLessons"
                checked={settings.groupLessons}
                onChange={handleCheckboxChange}
              />
    
          </div>
          {business.groupLessons && iframeOpen !== 3 && <button className='profile-button' onClick={() => setIframeOpen(3)}>Zkopíruj na vlastní web</button>}
          {business.groupLessons && (iframeOpen === 3 || iframeOpen === "3") && <div className='iframe-text'>
            <p>
                {`<iframe scrolling='no'\n title="Reservation"\n style={{ width: '100%', height: '1200px', border: 'none' }}\n src={"/business/public/${business._id}/lessonsreservation/reservationform"}>\n</iframe>`}
            </p>
            <button className='profile-button' onClick={() => setIframeOpen(null)}>Zavřít</button>
          </div>
          }
           <div>
            {/*
              <h2 className="check-title">Hlavní stránka</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="homepage"
                checked={settings.homePage}
                onChange={handleCheckboxChange}
              />
              
            */}
          </div>
          <div className='hotel-number'>
          <h2 className='check-title'>Galerie:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="visiblePhoto"
                checked={settings.visiblePhoto}
                onChange={handleCheckboxChange}
              />
    
          </div>
          <div className='hotel-number'>
          <h2 className='check-title'>Pracovní doba:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="visibleWorkHours"
                checked={settings.visibleWorkHours}
                onChange={handleCheckboxChange}
              />
          </div>
          <div className='hotel-number'>
            <h2 className='check-title'>Popis:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="visibleDescription"
                checked={settings.visibleDescription}
                onChange={handleCheckboxChange}
              />
          </div>
          <div className='hotel-number'>
            <h2 className='check-title'>Kontaktní údaje:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="visibleCompanyData"
                checked={settings.visibleCompanyData}
                onChange={handleCheckboxChange}
              />
    
          </div>
          <div className='hotel-number'>
            <h2 className='check-title'>Mapa:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="visibleMap"
                checked={settings.visibleMap}
                onChange={handleCheckboxChange}
              />
          </div>
          <div className='hotel-number'>
            <h2 className='check-title'>Služby:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="visibleServices"
                checked={settings.visibleServices}
                onChange={handleCheckboxChange}
              />
          </div>
          <div className='hotel-number'>
          <h2 className='check-title'>Úvodní obrázek:</h2>
              <input
                className='hotel-input-checkbox'
                type="checkbox"
                name="coverImage"
                checked={settings.coverImage}
                onChange={handleCheckboxChange}
              />
    
          </div>
          </div>
          <button className='profile-button' type="submit">Aktualizovat nastavení</button>
        </form>
        {message && <p className='message'>{message}</p>}
    </div>}
    {
      activeDashboard === "popis" && <div>
        <BusinessProfileEditor />
      </div>
    }
    {
      activeDashboard === "sluzby" && <div >

          <form onSubmit={addService}>

<div className='basic-container'>
  <h2 className='check-title'>Název: </h2>
<input 
  className='basic-input hotel-input'
  type="text"
  placeholder=""
  name="name"
  value={services.name}
  onChange={handleServicesChange}
  required
/>
</div>
<div className='basic-container'>
<h2 className='check-title'>Popis: </h2>
<input 
  className='basic-input hotel-input' 
  type="text"
  placeholder=""
  name="description"
  value={services.description}
  onChange={handleServicesChange}
  required
/>
</div>
<div className='basic-container'>
<h2 className='check-title'>Cena: </h2>
<input 
  className='basic-input hotel-input'
  type="number"
  placeholder="Kč"
  name="price"
  value={services.price}
  onChange={handleServicesChange}
  required
/>
</div>
<div className='basic-container'>
<h2 className='check-title'>Doba trvání: </h2>
<select
  className='basic-input reservation-select'
  name="duration"
  id="duration-select"
  value={services.duration}
  onChange={handleServicesChange}
  required
>
  <option value="">Možnosti</option>
  <option value="15">15 minut</option>
  <option value="30">30 minut</option>
  <option value="45">45 minut</option>
  <option value="60">1 hodina</option>
  <option value="75">1 hodina 15 minut</option>
  <option value="90">1 hodina 30 minut</option>
  <option value="105">1 hodina 45 minut</option>
  <option value="120">2 hodiny</option>
  <option value="135">2 hodiny 15 minut</option>
  <option value="150">2 hodiny 30 minut</option>
  <option value="165">2 hodiny 45 minut</option>
  <option value="180">3 hodiny</option>
  <option value="195">3 hodiny 15 minut</option>
  <option value="210">3 hodiny 30 minut</option>
  <option value="225">3 hodiny 45 minut</option>
  <option value="240">4 hodiny</option>
  <option value="255">4 hodiny 15 minut</option>
  <option value="270">4 hodiny 30 minut</option>
  <option value="285">4 hodiny 45 minut</option>
  <option value="300">5 hodin</option>

</select>
</div>
<div className='basic-container'>
<h2 className='check-title'>Pro: </h2>
<select
  className='basic-input reservation-select'
  name="sex"
  id="sex-select"
  value={services.sex}
  onChange={handleServicesChange}
  required
>
  <option value="everyone">Všechny</option>
  <option value="female">Ženy</option>
  <option value="male">Muže</option>
  <option value="children">Děti</option>
</select>
</div>
<button className='profile-button' type="submit" disabled={loading}>
  {loading ? 'Ukládám...' : 'Přidat službu'}
</button>
</form>
{ business.visibleServices || business.salonReservation ? (<div>
          {
          Array.isArray(business.services) &&
          business.services.sort((a, b) => a.order - b.order)
          .map((service) => {
            
            return(
            <div className="service-item" key={service._id}>
              <div className="arrow-container">
      {service.order !== 1 ? <button onClick={() => orderUp(service._id)} className="arrow-button" aria-label="Posunout nahoru">
        <FaArrowUp />
      </button> : ""}
      {service.order !== business.services.length ? <button onClick={() => orderDown(service._id)} className="arrow-button" aria-label="Posunout dolů">
        <FaArrowDown />
      </button> : ""}
    </div>
              <div className="all-service-description">
              <h4 className="service-name">{service.name}</h4>
              <p className="service-description">{service.description}</p>
              <div>
                {service.sex ? <p className='service-sex'>{service.sex === "everyone" ? "Všichni"
                 : service.sex === "female" ? "Ženy"
                 : service.sex === "male" ? "Muži"
                 : service.sex === "children" ? "Děti"
                 : ""                
                 }</p> : <p className='service-sex-nothing'></p> } 
              </div>
              <div className="all-service-price">
                  <p className="service-duration">{service.duration} minut</p>
                  <p className="service-price">{service.price} Kč</p>
              </div>
              <div className="delete-button-container">
              <button className="delete-button" onClick={() => deleteService(service._id)}>
                  Smazat
              </button>
              </div>
            </div>
            </div>
          )})}
        </div>) : <div></div> }
</div>
    }
    {
      activeDashboard === "skupinove" && <BusinessLessons />
    }
    {
      activeDashboard === "booking" && <HotelReservationForm />
    }
    {
      activeDashboard === "uvodni" && <CoverImageUpload />
    }
    {
      activeDashboard === "galerie" && <ImageUpload/>
    }
        {activeDashboard === "doba" && 
            <form onSubmit={formSubmit}>

              {workHours.map((entry, index) => (
                <div key={index} className="work-hour-time-setting">
                  <h2 className='check-title'>{entry.day}</h2>
          
                  <div>
                    <input
                      type="time"
                      value={entry.start}  // Používáme hodnotu z workHours
                      onChange={(e) => handleWorkhoursChange(index, 'start', e.target.value)}
                      placeholder="Začátek"
                      className="input-time"
                      min="00:00"
                      max="23:45"
                      step="900"
                    />
                    
                    <input
                      type="time"
                      value={entry.end}  // Používáme hodnotu z workHours
                      onChange={(e) => handleWorkhoursChange(index, 'end', e.target.value)}
                      placeholder="Konec"
                      className="input-time"
                      min="00:00"
                      max="23:45"
                      step="900"
                    />
                  </div>
                  
                </div>
              ))}
          
              <button className="profile-button" type="submit" disabled={loading}>
                Upravit otevírací hodiny
              </button>
              {message && <p className='message'>{message}</p>}
            </form>
          
        }
        {
          activeDashboard ==="kontakt" && <form onSubmit={formSubmit}>
               


          <div className='settings-container'>
          <h2 className='check-title'>Název podniku:</h2>
            <input
              className="hotel-input"
              type='text'
              name="name"
              value={updateBusinessProfile.name}
              onChange={inputChange}
            />
          </div>
  
          <div className='settings-container'>
          <h2 className='check-title'>Vlastník/Pracovník:</h2>
            <input
              className="hotel-input"
              type='text'
              name="owner"
              value={updateBusinessProfile.owner}
              onChange={inputChange}
            />
          </div>
  
          <div className='settings-container'>
          <h2 className='check-title'>Email:</h2>
          <input
            className="hotel-input"
            type="email"
            name="email"
            value={updateBusinessProfile.email || ''}
            onChange={inputChange}
          />
          </div>
          <div className='settings-container'>
          <h2 className='check-title'>Telefon:</h2>
          <input
            className="hotel-input"
            type="text"
  
            name="phone"
            value={updateBusinessProfile.phone || ''}
            onChange={inputChange}
          />
                  </div>
  
          <div className='settings-container'>
          <h2 className='check-title'>IČ:</h2>
          <input
            className="hotel-input"
            type="text"
  
            name="ic"
            value={updateBusinessProfile.ic || ''}
            onChange={inputChange}
          />
                  </div>
  
          <div className='settings-container'>
          <h2 className='check-title'>DIČ:</h2>
          <input
            className="hotel-input"
            type="text"
            name="dic"
            value={updateBusinessProfile.dic || ''}
            onChange={inputChange}
          />
                  </div>
  
          <div className='settings-container'>
          <h2 className='check-title'>Ulice:</h2>
          <input
            className="hotel-input"
            type="text"
            name="street"
            value={updateBusinessProfile.street || ''}
            onChange={inputChange}
          />
                  </div>
  
          <div className='settings-container'>
          <h2 className='check-title'>Č.P.:</h2>
          <input
            className="hotel-input"
            type="text"
            name="houseNumber"
            value={updateBusinessProfile.houseNumber || ''}
            onChange={inputChange}
          />
                  </div>
  
          <div className='settings-container'>
          <h2 className='check-title'>Město:</h2>
          <input
            className="hotel-input"
            type="text"
            name="city"
            value={updateBusinessProfile.city || ''}
            onChange={inputChange}
          />
                  </div>
  
          <div className='settings-container'>
          <h2 className='check-title'>PSČ:</h2>
          <input
            className="hotel-input"
            type="text"
            name="postalCode"
            value={updateBusinessProfile.postalCode || ''}
            onChange={inputChange}
          />
          </div>
  
  
  
  <div>
          <button className='profile-button' type="submit" disabled={loading}>
            {loading ? 'Ukládám...' : 'Upravit profil'}
          </button>
  
          </div>
          {message && <p className='message'>{message}</p>}
  
        </form>
        }

      
        </div>
  </div>
</div>

      </div>
    </div>
  );
};

export default BusinessProfile;